import Link from 'launch/components/Link';
import React from 'react';

const TermsLink = () => (
    <Link href="/legal/terms-of-use" target="_blank" variations={['default']}>
        {__('Terms')}
    </Link>
);

export default TermsLink;
